<template>
  <fts-design-modal
    title="Listing Actions"
    class="fts-listing-action-design-modal"
    ref="ftsDesignModal"
  >
    <!-- body -->
    <template #body>
      <div>
        <fts-form-label placement="top">
          Actions
        </fts-form-label>
        <div
          v-for="x in formData.actions"
          :key="x.id"
          class="action-wrapper"
        >
          <div class="action-wrapper__l">
            <fts-label-group
              :list="options"
              :item-id="x.id"
              :emoji="x.type === 'activity' || x.type === 'action'"
              :label-color="x.type === 'activity' || x.type === 'action'"
              class="action-info"
            />
            <div class="action-badge">
              {{x.type}}
            </div>
          </div>

          <fts-btn
            icon
            text
            @click="removeAction(x)"
          >
            <font-awesome-icon :icon="['far', 'trash-alt']" />
          </fts-btn>
        </div>

        <fts-select
          v-model="selector"
          :options="getOptions"
          :reduce="x => ({ id: x.id, type: x.type })"
          :clear-search-on-blur="() => true"
          :clear-search-on-select="false"
          :close-on-select="false"
          comfort-design
          @option:selected="selectAction"
          ref="selector"
          class="action-selector"
        >
          <template #option="{ option }">
            <fts-label-group
              :list="getOptions"
              :item-id="option.id"
              :emoji="option.type === 'activity' || option.type === 'action'"
              :label-color="option.type === 'activity' || option.type === 'action' ? option.color : null"
            />
          </template>
        </fts-select>
      </div>
    </template>
    <!-- footer-->
    <template #footerRight>
      <fts-btn
        text
        @click="beforeClose"
      >
        Cancel
      </fts-btn>
      <fts-btn
        outline
        color="primary"
        @click="done"
      >
        <font-awesome-icon :icon="['fas', 'check']" />Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from 'diff-json';

import FTSDesignModal from './FTSDesignModal';
import FTSSelect from '../elements/FTSSelect';
import FTSBtn from '../elements/FTSBtn';
import FTSCheckbox from '../elements/FTSCheckbox';
import FTSFormLabel from '../elements/FTSFormLabel';
import FTSLabelGroup from '../elements/FTSLabelGroup';

export default {
  components: {
    'fts-design-modal': FTSDesignModal,
    'fts-btn': FTSBtn,
    'fts-select': FTSSelect,
    'fts-checkbox': FTSCheckbox,
    'fts-form-label': FTSFormLabel,
    'fts-label-group': FTSLabelGroup
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    activities: null,
    documents: null,
    actions: null,
    selector: null,
    options: [],
  }),
  methods: {
    async show(formData, payload) {
      this.formData = _.cloneDeep(formData);

      this.options = [
        { id: 'create', name: 'Create', type: 'standardActivity' },
        { id: 'view', name: 'View', type: 'standardActivity' },
        { id: 'edit', name: 'Edit', type: 'standardActivity' },
        { id: 'delete', name: 'Delete', type: 'standardActivity' },
        { id: 'changeStatus', name: 'Change State', type: 'standardActivity' },
        { id: 'duplicate', name: 'Duplicate', type: 'standardActivity' }
      ];

      if (payload) {
        if (Array.isArray(payload.activities)) {
          this.options = this.options.concat(
            payload.activities.map((x) => ({
              id: x.id,
              name: x.name,
              color: x.color,
              emoji: x.emoji,
              type: 'activity'
            }))
          );
        }

        if (Array.isArray(payload.actions)) {
          this.options = this.options.concat(
            payload.actions.map((x) => ({
              id: x.id,
              name: x.name,
              color: x.color,
              emoji: x.emoji,
              type: 'action'
            }))
          )
        }
        
        if (Array.isArray(payload.documents)) {
          this.options = this.options.concat(
            payload.documents.map((x) => ({
              id: x.id,
              name: x.name,
              color: x.color,
              emoji: x.emoji,
              type: 'document'
            }))
          )
        }
      }

      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              event.stopImmediatePropagation();
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    }
                  }
                ]
              });
            } else {
              this.reset();
            }
          }
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.reset();
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    reset() {
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    selectAction(val) {
      this.selector = null;
      this.formData.actions.push(val);
    },
    removeAction(item) {
      const index = this.formData.actions.findIndex((x) => x.id === item.id);
      if (index > -1) {
        this.formData.actions.splice(index, 1);
      }
    }
  },
  computed: {
    getOptions() {
      let options = [];
      if (Array.isArray(this.options)) {
        options = this.options;
      }
      if (this.formData && Array.isArray(this.formData.actions)) {
        options = options.filter((x) =>
          !this.formData.actions.some((y) => y.id === x.id)
        );
      }
      return options;
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-listing-action-design-modal {
  .action-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 0.125rem;
    .action-wrapper__l {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      margin-right: 1rem;
    }
    .action-info {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .action-badge {
      margin-left: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      border-radius: 0.25rem;
      background-color: var(--fts-gray-200);
      color: var(--fts-gray-600);
      font-size: 0.75rem;
      line-height: 1rem;
    }
    & + .action-selector {
      margin-top: 0.75rem;
    }
  }
}
</style>